import { render, staticRenderFns } from "./test.vue?vue&type=template&id=7c00be80&scoped=true&"
import script from "./test.vue?vue&type=script&lang=js&"
export * from "./test.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c00be80",
  null
  
)

component.options.__file = "test.vue"
export default component.exports